/** Inventory assets CSV contract (aligned with sima-admin assets_template.csv). */

export const INVENTORY_ASSETS_CSV = {
  filename: 'assets_template.csv',
  headers: [
    'brand_name',
    'category_name',
    'asset_tag_no',
    'model',
    'serial_number',
    'function',
    'sw_provider',
    'warranty_date',
    'order_received_date',
    'ram',
    'disk_space',
    'os_version',
    'os_status',
    'ms_office',
    'processor',
    'cpu',
    'ip_address',
    'mac_address',
  ] as const,
  exampleRow: [
    'HP',
    'Desktop PC',
    'AST001',
    '800 G5',
    'SN123456',
    'Workstation',
    'HP Inc.',
    '12/31/2024',
    '1/15/2024',
    '16GB',
    '512GB SSD',
    'Windows 11 Pro',
    'Windows is activated',
    'Office 365',
    'Intel i7',
    'Intel Core i7-10700',
    '192.168.1.100',
    '00:1A:2B:3C:4D:5E',
  ] as const,
  comments: [
    'brand_name and category_name must exist in Asset Catalog',
    'asset_tag_no is the asset tag (alias: tag_number)',
    'Option columns (ram, cpu, …) must match catalog option names',
    'os_status: e.g. "Windows is activated" or "Windows need activation"',
    'Dates: m/d/Y (e.g. 1/15/2024)',
  ] as const,
  mapRow: (row: Record<string, unknown>): string[] => [
    String(row.brand_name ?? ''),
    String(row.category_name ?? ''),
    String(row.tag_number ?? row.asset_tag_no ?? ''),
    String(row.model ?? ''),
    String(row.serial_number ?? ''),
    String(row.function ?? ''),
    String(row.sw_provider ?? ''),
    String(row.warranty_date ?? ''),
    String(row.order_received_date ?? ''),
    String(row.ram ?? ''),
    String(row.disk_space ?? ''),
    String(row.os_version ?? ''),
    String(row.os_status ?? ''),
    String(row.ms_office ?? ''),
    String(row.processor ?? ''),
    String(row.cpu ?? ''),
    String(row.ip_address ?? ''),
    String(row.mac_address ?? ''),
  ],
}
